import { toast } from "sonner";

const loadScript = () => new Promise((resolve) => {
  if (window.Razorpay) return resolve(true);
  const s = document.createElement("script");
  s.src = "https://checkout.razorpay.com/v1/checkout.js";
  s.onload = () => resolve(true);
  s.onerror = () => resolve(false);
  document.body.appendChild(s);
});

// Opens Razorpay checkout for an order created by the Taxmandi backend; resolves with the Razorpay response.
export async function openRazorpay(order) {
  if (!(await loadScript())) {
    toast.error("Could not load Razorpay. Check your connection.");
    return null;
  }
  return new Promise((resolve) => {
    const rz = new window.Razorpay({
      key: order.key_id, order_id: order.order_id, amount: order.amount, currency: order.currency || "INR",
      name: order.name || "Taxmandi", description: order.description, prefill: order.prefill, theme: { color: "#132B5E" },
      handler: (resp) => resolve(resp),
      modal: { ondismiss: () => resolve(null) },
    });
    rz.open();
  });
}
